const RtnConfig: any = new Object();

// Declare your configuration here
// RtnConfig['service.URL'] = '<%= SERVICE_URL %>';
RtnConfig['service.URL'] = 'http://127.0.0.1:8080';
RtnConfig['token.key'] = 'id_token';
RtnConfig['token.expired'] = 900000;

export { RtnConfig };
